import { FC } from 'react';

import * as Colors from '../../theme/colors';

type MediumProps = {
  width?: string;
  color?: string;
};

export const Medium: FC<MediumProps> = ({ width, color }) => (
  <svg
    role="img"
    width={width ?? '24'}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="8"
      stroke={color ?? Colors.medium.primary}
      strokeWidth="2"
    />
  </svg>
);
